function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM8.30583 13.3417C8.77583 11.8508 9.66583 10.065 9.82333 9.61333C10.0508 8.9575 9.6475 8.66667 8.37333 9.7875L8.09 9.25417C9.54333 7.67333 12.5358 7.31583 11.5175 9.765C10.8817 11.2942 10.4267 12.3267 10.1667 13.1233C9.7875 14.2842 10.745 13.8133 11.6825 12.9475C11.81 13.1558 11.8517 13.2233 11.9792 13.4633C9.8975 15.445 7.58667 15.62 8.30583 13.3417ZM12.2575 6.53417C11.8142 6.91167 11.1575 6.90333 10.79 6.51583C10.4225 6.12833 10.4842 5.50917 10.9267 5.13167C11.37 4.75417 12.0267 4.76333 12.3942 5.15C12.76 5.53833 12.7 6.1575 12.2575 6.53417Z",
    style: {
      fill: "rgb(0, 48, 69)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSign);
export default __webpack_public_path__ + "static/media/info-sign.7a7a88d34dba3628d6b42f8985a670af.svg";
export { ForwardRef as ReactComponent };